import React from 'react'
import styled from 'styled-components'
import { margin, MarginProps, position, PositionProps } from 'styled-system'

import IconButton from '../../IconButton'
import { Z_INDEX } from 'utils/constants'

type Props = MarginProps & {
  customCancel?: React.ReactNode
  customConfirm?: React.ReactNode
  isCancelDisabled?: boolean
  isConfirmDisabled?: boolean
  onClickCancel?: () => void
  onClickConfirm?: () => void
}

const InlineInputButtons: React.FC<Props & PositionProps> = ({
  customCancel,
  customConfirm,
  isCancelDisabled,
  isConfirmDisabled,
  onClickCancel,
  onClickConfirm,
  position = 'absolute',
  ...marginProps
}) => (
  <Container position={position} {...marginProps}>
    {customConfirm ? (
      customConfirm
    ) : (
      <IconButton
        iconColor={isConfirmDisabled ? 'gray10' : 'green3'}
        disabled={isConfirmDisabled}
        icon={['fa', 'check']}
        onClick={onClickConfirm}
        variant="checkButtonGreenV2"
      />
    )}
    {customCancel ? (
      customCancel
    ) : (
      <IconButton
        iconColor="red"
        disabled={isCancelDisabled}
        icon={['far', 'times']}
        onClick={onClickCancel}
        variant="xButtonRedV2"
      />
    )}
  </Container>
)

const Container = styled.div<MarginProps & PositionProps>`
  ${margin}
  background: ${(p) => p.theme.colors.white};
  display: flex;
  gap: 4px;
  justify-content: flex-end;
  ${position}
  right: 0;
  z-index: ${Z_INDEX.menuListPopOver};
`

export default InlineInputButtons
